import { type ButtonHTMLAttributes, forwardRef } from 'react';

import type { ButtonVariant } from './Button';
import { classNames } from './classNames';

export type IconButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  'aria-label': string;
  size?: 'sm' | 'md' | 'lg';
  variant?: ButtonVariant;
};

export const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(
  ({ className, size = 'md', type = 'button', variant = 'ghost', ...props }, ref) => (
    <button
      ref={ref}
      className={classNames(
        'hotam-icon-button',
        `hotam-icon-button--${size}`,
        `hotam-icon-button--${variant}`,
        className,
      )}
      type={type}
      {...props}
    />
  ),
);

IconButton.displayName = 'IconButton';
